import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-24 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
          Ready to Start Your Journey?
        </h2>
        <p className="text-white/70 text-lg mb-10 max-w-2xl mx-auto">
          Let us create an unforgettable yachting experience tailored just for you
        </p>
        <Link
          to="/booking"
          className="inline-block px-10 py-4 bg-orange-500 text-white font-medium rounded-lg hover:bg-orange-600 transition-all duration-300 transform hover:scale-105"
        >
          Book Your Charter
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
